import React from "react";
import { Link } from "react-router-dom";
import { Dices, Mail, Info } from "lucide-react";
import { SITE } from "../mock";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer className="mt-20 border-t border-amber-400/10 bg-[#0a0e17]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid gap-10 md:grid-cols-4">
        <div className="md:col-span-2">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-lg bg-gradient-to-br from-amber-300 to-amber-500 flex items-center justify-center">
              <Dices className="w-4 h-4 text-[#0b0f1a]" strokeWidth={2.5} />
            </div>
            <div className="text-lg font-bold text-amber-300">{SITE.name}</div>
          </div>
          <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-md">
            {SITE.name} ek informational result aur chart archive hai. Yahan aapko daily Madhur aur Starline
            ke updates ek hi jagah par milte hain.
          </p>
        </div>

        <div>
          <div className="text-sm font-semibold text-slate-200 mb-3">Quick Links</div>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><Link to="/" className="hover:text-amber-300">Home</Link></li>
            <li><Link to="/madhur-chart" className="hover:text-amber-300">Madhur Chart</Link></li>
            <li><Link to="/starline-chart" className="hover:text-amber-300">Starline Chart</Link></li>
            <li><Link to="/about" className="hover:text-amber-300">About</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-sm font-semibold text-slate-200 mb-3">Contact</div>
          <ul className="space-y-2 text-sm text-slate-400">
            <li className="flex items-center gap-2"><Mail className="w-4 h-4 text-amber-300" /> info@madhurlottery.in</li>
            <li className="flex items-center gap-2"><Info className="w-4 h-4 text-amber-300" /> Informational Platform</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/5">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-5 text-xs text-slate-500 flex flex-col md:flex-row justify-between gap-2">
          <div>
            <strong className="text-slate-400">Disclaimer:</strong> Yeh website sirf informational purposes ke liye banayi gayi hai.
            Hum kisi bhi tarah ki gambling ya betting ko promote nahi karte.
          </div>
          <div>&copy; {SITE.founded}-{year} {SITE.name}</div>
        </div>
      </div>
    </footer>
  );
}
